import React, { useEffect, useState } from "react";
import { Box, Tab, Grid } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useLocation, useNavigate } from "react-router-dom"; // Import useLocation and useNavigate
import { useSelector, useDispatch } from "react-redux";
import CombinedPopup from "../../components/Popups/CombinedPopup";
import List from "./List";
import CommissionPayment from "./CommissionPayment";
import AffDashboard from "./Dashhboard";
import CreateAffililiate from "./CreateAffililiate";
import "./index.scss";
import Loader from "../../reusableComponents/Loader";
import CommissionSlider from "./CommissionSlider";
import RepeatDiscountSlider from "./RepeatDiscountSlider";
import DiscountSlider from "./DiscountSlider";
import overviewIcon from "../../assets/icons/overview.svg";
import affCodeIcon from "../../assets/icons/affiliate-code.svg";
import commissionIcon from "../../assets/icons/commission-payment.svg";

const AffiliateMarketing = () => {
  const dispatch = useDispatch();
  const location = useLocation(); // Use location to read the URL
  const navigate = useNavigate(); // Use navigate for URL manipulation
  const { url, referalCode, aff_percentage_range } = useSelector(
    (state) => state.user
  );
  const [value, setValue] = useState("5");
  const [activeTab, setActiveTab] = useState(5);
  const loader = useSelector((state) => state.loader.is_loading);
  const [open, setOpen] = useState(loader);
  const [ShowPopup, setShowPopup] = useState(false);
  const [CombinedPUHead, setCombinedPUHead] = useState("");
  const [CombinedPUBody, setCombinedPUBody] = useState("");
  const [PopUpType, setPopUpType] = useState("");
  const [Show, setShow] = useState(false);

  useEffect(() => {
    setOpen(loader);
  }, [loader]);

  // Parse query parameters to determine which tab to set
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const activeTabParam = params.get("tab");
    if (activeTabParam) {
      setActiveTab(Number(activeTabParam)); // Set the active tab based on the URL parameter
      setValue(activeTabParam); // Sync TabContext value with the active tab
    }
  }, [location.search]);

  const handleChange = (event, newValue) => {
    event.preventDefault();
    setValue(newValue);
    setActiveTab(Number(newValue)); // Update the active tab state

    // Update the URL with the new tab
    navigate(`/affiliateMarketing?tab=${newValue}`);
  };

  const handleCross = () => {
    setShow(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Grid
      className="ContainerTab affiliate-marketing PageContainer"
      container
      p={1}
      style={{ position: "relative" }}
    >
      <Loader open={open} />
      <CombinedPopup
        type={PopUpType}
        trigger={ShowPopup}
        setTrigger={setShowPopup}
        head={CombinedPUHead}
        subhead={CombinedPUBody}
        setShow={setShow}
        onClick={handleCross}
      />
      <TabContext value={value}>
        <Box className="new-tabination-wrapper" sx={{ width: "100%" }}>
          <TabList
            onChange={handleChange}
            aria-label="lab API tabs example"
            className="newTabination affiliate-marketing-tabination"
          >
            <Tab
              className={
                activeTab === 5
                  ? "newTabination-item active"
                  : "newTabination-item"
              }
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    className="tabIcon"
                    src={overviewIcon}
                    alt=""
                    style={{ marginRight: "8px" }}
                  />
                  Overview
                </div>
              }
              value="5"
            />
            {/* <Tab
              className={activeTab === 1 ? "newTabination-item active" : "newTabination-item"}
              label="Get a Link"
              value="1" /> */}
            {/* <Tab
              className={
                activeTab === 2
                  ? "newTabination-item active"
                  : "newTabination-item"
              }
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    className="tabIcon"
                    src={affCodeIcon}
                    alt=""
                    style={{ marginRight: "8px" }}
                  />
                  Affiliate Codes
                </div>
              }
              value="2"
            /> */}
            <Tab
              className={
                activeTab === 4
                  ? "newTabination-item active"
                  : "newTabination-item"
              }
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    className="tabIcon"
                    src={commissionIcon}
                    alt=""
                    style={{ marginRight: "8px" }}
                  />
                  Commission Payment
                </div>
              }
              value="4"
            />
          </TabList>
        </Box>
        <TabPanel
          style={{ padding: "0rem", marginTop: "10px", width: "100%" }}
          value="1"
        >
          <CreateAffililiate />
        </TabPanel>
        <TabPanel
          style={{ padding: "1rem", marginTop: "10px", width: "100%" }}
          value="2"
          className="affiliate-code-table"
        >
          <Box>
            <List />
          </Box>
        </TabPanel>
        <TabPanel
          className="affiliate-code-table"
          style={{ padding: "1rem", marginTop: "10px", width: "100%" }}
          value="4"
        >
          <CommissionPayment />
        </TabPanel>
        <TabPanel
          className="aff-dashboard"
          style={{ padding: "0rem", marginTop: "10px", width: "100%" }}
          value="5"
        >
          <Box>
            <AffDashboard />
          </Box>
        </TabPanel>
      </TabContext>
    </Grid>
  );
};

export default AffiliateMarketing;
